import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { AccordionList, AccordionListItem } from 'components/AccordionList';
import { Heading, Paragraph } from 'components/Typography';

export const ScreenerResultsFAQSection: React.FC = () => {
  const {
    results: { targetPatient },
  } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  return (
    <section>
      <AccordionList title="">
        <AccordionListItem
          summary={
            <Heading level="h7" className="font-semibold">
              {t(`screener.results.faq.whatHappens.title.${targetPatient}`)}
            </Heading>
          }
        >
          <Paragraph>{t(`screener.results.faq.whatHappens.text.${targetPatient}`)}</Paragraph>
        </AccordionListItem>

        <AccordionListItem
          summary={
            <Heading level="h7" className="font-semibold">
              {t(`screener.results.faq.whatToBring.title.${targetPatient}`)}
            </Heading>
          }
        >
          <Paragraph>{t(`screener.results.faq.whatToBring.text.${targetPatient}`)}</Paragraph>
        </AccordionListItem>
      </AccordionList>
    </section>
  );
};
